import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
// import Newsletter from '../layouts/Newsletter';
import Content from '../sections/home/Content';

class Home extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Raj Jeweller | Homepage</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                {/* <Newsletter/> */}
                <Header/>
                <Content/>
                <Footer/>
            </Fragment>
        );
    }
}

export default Home;